/**
 * ╔══════════════════════════════════════════════════════╗
 * ║   BLACKBOY — Cart Fly Animation                     ║
 * ║   Works on: product pages, quick add, wishlist,     ║
 * ║   recently viewed, and any other ATC button.        ║
 * ║                                                     ║
 * ║   Installation: see setup guide                     ║
 * ╚══════════════════════════════════════════════════════╝
 */

(function () {
  'use strict';

  /* ── CONFIG ─────────────────────────────────────────────────
     Change these to customise the animation.
  ──────────────────────────────────────────────────────────── */
  var CONFIG = {
    logoUrl:     'https://cdn.shopify.com/s/files/1/2771/8350/files/Black_Boy_Inflate.png?v=1753565317',
    flySize:     30,   // px  — size of the flying logo
    flyDuration: 680,  // ms  — how long the flight takes
    arcLift:    -140,  // px  — how high it curves (negative = up)
  };

  /* ── ADD-TO-CART BUTTON SELECTORS ───────────────────────────
     Covers: Dawn, Debut, Impulse, Brooklyn, Turbo, Prestige,
     quick-add drawers, Swym Wishlist, Wishlist King, Growave,
     Bold Wishlist, Recently Viewed sections, and more.
  ──────────────────────────────────────────────────────────── */
  var ATC_SELECTORS = [
    /* — Native Shopify / product forms — */
    'button[name="add"]',
    '[data-add-to-cart]',
    '[data-btn-addtocart]',
    '.product-form__cart-submit',
    '.product-form__submit',
    '.btn--add-to-cart',

    /* — Quick add drawers & modals — */
    '.quick-add__submit',
    '[data-quick-add-btn]',
    '[data-quick-shop-submit]',
    '.quickadd-submit',
    '[data-action="add-to-cart"]',

    /* — Wishlist app ATC buttons — */
    '[data-swym-add-to-cart]',          /* Swym / Wishlist Plus */
    '[data-wk-add-to-cart]',            /* Wishlist King        */
    '.growave-wishlist__atc',           /* Growave              */
    '[data-bold-wishlist-atc]',         /* Bold Wishlist        */
    '.wishlist-btn-atc',                /* generic              */
    '[data-wishlist-add]',

    /* — Recently viewed / recommendation sections — */
    '.recently-viewed .btn',
    '.recently-viewed [type="submit"]',
    '.product-recommendations .btn',
    '.product-recommendations [type="submit"]',
    '[data-section-type="recently-viewed-products"] [name="add"]',
    '[data-section-type="product-recommendations"] [name="add"]',
  ].join(', ');

  /* ── CART ICON SELECTORS ────────────────────────────────────
     The animation lands ON the first matching element.
     Add your theme's selector at the top if it isn't here.
  ──────────────────────────────────────────────────────────── */
  var CART_SELECTORS = [
    /* — Dawn (the most common free theme) — */
    '.header__icon--cart',
    '.cart-count-bubble',

    /* — Generic SVG/icon inside cart link — */
    'a[href="/cart"] .icon',
    'a[href="/cart"] svg',
    'a[href="/cart"] img',

    /* — Named classes used by popular paid themes — */
    '.cart-icon',
    '.icon-cart',
    '.header-cart',
    '.site-header__cart',
    '.cart-link',
    '[data-cart-icon]',
    '[data-icon="cart"]',
    '#CartToggle',
    '.js-cart-count',
  ].join(', ');

  /* ─────────────────────────────────────────────────────────── */

  /* Preload the logo image so the first animation is instant */
  var _preload = new Image();
  _preload.src = CONFIG.logoUrl;

  /* Inject CSS once */
  function injectStyles() {
    if (document.getElementById('bb-cart-fly-styles')) return;
    var s = document.createElement('style');
    s.id = 'bb-cart-fly-styles';
    s.textContent = [
      '@keyframes bb-btn-press{',
        '0%{transform:scale(1)}',
        '40%{transform:scale(0.93)}',
        '100%{transform:scale(1)}',
      '}',
      '@keyframes bb-cart-bounce{',
        '0%{transform:scale(1) rotate(0)}',
        '20%{transform:scale(1.3) rotate(-7deg)}',
        '45%{transform:scale(0.88) rotate(5deg)}',
        '70%{transform:scale(1.12) rotate(-3deg)}',
        '100%{transform:scale(1) rotate(0)}',
      '}',
      '.bb-btn-press{',
        'animation:bb-btn-press 0.22s cubic-bezier(.36,.07,.19,.97) forwards !important;',
      '}',
      '.bb-cart-bounce{',
        'animation:bb-cart-bounce 0.5s cubic-bezier(.36,.07,.19,.97) !important;',
      '}',
    ].join('');
    document.head.appendChild(s);
  }

  /* Easing — smooth acceleration + deceleration */
  function easeInOutQuart(t) {
    return t < 0.5 ? 8*t*t*t*t : 1 - Math.pow(-2*t+2,4)/2;
  }

  /* Find the cart element */
  function getCartEl() {
    return document.querySelector(CART_SELECTORS);
  }

  /* Bounce the cart icon */
  function bounceCart() {
    var el = getCartEl();
    if (!el) return;
    el.classList.remove('bb-cart-bounce');
    void el.offsetWidth; /* force reflow so animation restarts */
    el.classList.add('bb-cart-bounce');
    el.addEventListener('animationend', function () {
      el.classList.remove('bb-cart-bounce');
    }, { once: true });
  }

  /* Create the flying logo and animate it along a curved path */
  function flyToCart(btn) {
    var cartEl = getCartEl();
    if (!cartEl) return;

    var btnRect  = btn.getBoundingClientRect();
    var cartRect = cartEl.getBoundingClientRect();

    /* Start = centre of the button | End = centre of cart icon */
    var startX = btnRect.left  + btnRect.width  / 2;
    var startY = btnRect.top   + btnRect.height / 2;
    var endX   = cartRect.left + cartRect.width  / 2;
    var endY   = cartRect.top  + cartRect.height / 2;

    /* Bezier control point — lifted above the straight-line midpoint */
    var cpX = (startX + endX) / 2;
    var cpY = Math.min(startY, endY) + CONFIG.arcLift;

    /* Build the flying element */
    var clone = document.createElement('img');
    clone.src = CONFIG.logoUrl;
    clone.setAttribute('aria-hidden', 'true');
    clone.style.cssText =
      'position:fixed;' +
      'width:'  + CONFIG.flySize + 'px;' +
      'height:' + CONFIG.flySize + 'px;' +
      'object-fit:contain;' +
      'left:' + (startX - CONFIG.flySize / 2) + 'px;' +
      'top:'  + (startY - CONFIG.flySize / 2) + 'px;' +
      'pointer-events:none;' +
      'z-index:99999;' +
      'will-change:transform,opacity;';
    document.body.appendChild(clone);

    var startTime = performance.now();

    function step(now) {
      var rawT = Math.min((now - startTime) / CONFIG.flyDuration, 1);
      var ease = easeInOutQuart(rawT);

      /* Quadratic Bézier: position along the arc */
      var bx = Math.pow(1-ease,2)*startX + 2*(1-ease)*ease*cpX + ease*ease*endX;
      var by = Math.pow(1-ease,2)*startY + 2*(1-ease)*ease*cpY + ease*ease*endY;

      /* Shrink to ~22% of original size as it flies */
      var scale   = 1 - rawT * 0.78;
      /* Fade out in the last 18% of the journey */
      var opacity = rawT > 0.82 ? 1 - ((rawT - 0.82) / 0.18) : 1;

      clone.style.transform = 'translate(' + (bx - startX) + 'px,' + (by - startY) + 'px) scale(' + scale + ')';
      clone.style.opacity   = opacity;

      if (rawT < 1) {
        requestAnimationFrame(step);
      } else {
        clone.remove();
        bounceCart();
      }
    }

    requestAnimationFrame(step);
  }

  /* Track which buttons are mid-animation (WeakSet = no memory leaks) */
  var animating = new WeakSet();

  /* Single delegated listener — catches every ATC button, anywhere, anytime */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(ATC_SELECTORS);
    if (!btn) return;
    if (animating.has(btn)) return;

    animating.add(btn);

    /* 1. Micro-press */
    btn.classList.add('bb-btn-press');
    btn.addEventListener('animationend', function () {
      btn.classList.remove('bb-btn-press');
    }, { once: true });

    /* 2. Fly (tiny delay lets the press render first) */
    setTimeout(function () {
      flyToCart(btn);
      /* Cooldown — prevents double-trigger on fast clicks */
      setTimeout(function () { animating.delete(btn); }, 1200);
    }, 130);

  }, true /* capture phase — runs before theme JS intercepts */);

  injectStyles();

})();